import { Vue, BitrixVue } from 'ui.vue';
import { userStore } from 'germes.multibasket';
Vue.component('vue-product-quantity-analog-toggle-button', {
    data() {
        return {};
    },
    computed: {
        localize() {
            return Vue.getFilteredPhrases("");
        },
        isAnalog(state) {
            return state.$props.productAnalog == 'Y';
        },
        basketProduct(state) {
            return state.$store.hasModule("basket") ? state.$store.getters['basket/findItem'](state.$props.productId) : null;
        },
        catalogProduct(state) {
            return state.$store.getters['catalog/findItem'](state.$props.productId);
        },
        basketStatus(state) {
            return state.$store.getters['basket/basketStatus'];
        },
        catalogProductHaveAnalog(state) {
            return state.basketProduct && state.basketProduct.ANALOGS
                ? state.basketProduct.ANALOGS?.length && state.basketProduct?.CAN_BUY_IN_PERCENT < 100
                : false;
        },
    },
    methods: {
        showAnalogs: function (event) {
            var offer = this.catalogProduct,
                product_id = offer.ID,
                item_id = offer.ID,
                arAnalogs = offer.ANALOGS,
                uniq_id = "basketAnalogs-message-" + item_id,
                arResult = {
                    "ID": item_id,
                    "ANALOGS": arAnalogs
                };
            if (offer.XML_ID != undefined) {
                let code = (offer.XML_ID).split('#')[1];
                if (code != undefined) {
                    offer.XML_ID = code;
                }
            }
            // window.test_offer = offer;
            if (typeof window.PopupWindowManagerAnalogs == 'undefined') {
                window.PopupWindowManagerAnalogs = {};
            }
            if (typeof window.PopupWindowManagerAnalogs?.[uniq_id] != 'object') {
                window.PopupWindowManagerAnalogs[uniq_id] = BX.PopupWindowManager.create(uniq_id, null, {
                    width: (isMobile.any()) ? window.outerWidth : (window.outerWidth / 2), // ширина окна
                    content: '<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>',
                    closeIcon: {
                        right: "20px",
                        top: "10px",
                        opacity: "1"
                    },
                    titleBar: {
                        content: BX.create("span", {
                            html: '<h1 class="h4 py-2 text-center">Заказываемого товара не достаточно на складе, подбираем аналог...</h1>',
                            'props': {
                                'className': 'basketConfirmer-title-bar'
                            }
                        })
                    },
                    zIndex: 110,
                    offsetLeft: 0,
                    offsetTop: -(window.outerHeight / 4),
                    closeByEsc: false, // закрытие окна по esc
                    darkMode: false, // окно будет светлым или темным
                    autoHide: true, // закрытие при клике вне окна
                    draggable: {
                        restrict: false
                    }, // можно двигать или нет
                    resizable: true, // можно ресайзить
                    min_height: 100, // минимальная высота окна
                    min_width: 100, // минимальная ширина окна
                    darkMode: false,
                    lightShadow: false, // использовать светлую тень у окна
                    // angle: true, // появится уголок
                    overlay: {
                        backgroundColor: '#333',
                        opacity: 500
                    },
                    events: {
                        onPopupClose: function (PopupWindow) {
                            BX.onCustomEvent("OnAnalogWindowClose");
                            PopupWindow.destroy(); //удаление из DOM-дерева после закрытия
                            window.PopupWindowManagerAnalogs[uniq_id] = undefined;
                        },
                        onAfterPopupShow: function (PopupWindow) {
                            // show
                        }
                    },
                    buttons: [
                        /* new BX.PopupWindowButton({
                            text: "Распределить" ,
                            className: "popup-window-button-link" ,
                            events: {click: function(){
                                console.log(this);
                                console.log(window.PopupWindowManagerAnalogs[uniq_id]);
                                // $(window.PopupWindowManagerAnalogs[uniq_id].contentContainer).find("#item-analogs").find("input[name='quantity']");
                                // this.popupWindow.close();
                            }}
                        }), */
                        new BX.PopupWindowButton({
                            text: "Применить",
                            className: "popup-window-button-accept",
                            events: {
                                click: function () {
                                    BX.onCustomEvent("OnAnalogWindowAccept");
                                    // hide-analog-optionstoggle
                                    var hideBasketCheckAnalog = BX.findChild(BX(uniq_id), {
                                        tag: 'input',
                                        attribute: {
                                            "name": "hidebasketcheckanalog"
                                        },
                                        property: "checked"
                                    }, true);
                                    if (hideBasketCheckAnalog != null) {
                                        BX.userOptions.save("bitrix_catalog", "check_analogs", "hide_visual_analog_" + userStore.getters.basket_id, "1");
                                    }
                                    BX.onCustomEvent('OnBasketChange');
                                    this.popupWindow.close();
                                    window.PopupWindowManagerAnalogs[uniq_id] = undefined;
                                }
                            }
                        }),
                        new BX.PopupWindowButton({
                            text: "Отменить",
                            className: "popup-button-link-cancel",
                            events: {
                                click: function () {
                                    BX.onCustomEvent("OnAnalogWindowClose");
                                    this.popupWindow.close();
                                }
                            }
                        })
                    ]
                });
                BX.insertBefore(BX.create("span", {
                    html: '<input type="checkbox" name="hidebasketcheckanalog" value="1" id="hide-basket-check-analog"> отключить сервис подбора аналогов(до следующего заказа)',
                    'props': {
                        'className': 'hideBasketCheckAnalog-cont'
                    }
                }), BX.findChild(BX(uniq_id), {
                    "className": 'popup-window-button-accept'
                }, true));
                window.PopupWindowManagerAnalogs?.[uniq_id]?.show();
                BX.ajax({
                    url: '/ajax/analogs.php?SKU_PRODUCT_ID=' + item_id,
                    data: arResult,
                    method: 'POST',
                    dataType: 'html',
                    timeout: 30,
                    async: true,
                    processData: true,
                    scriptsRunFirst: false,
                    emulateOnload: true,
                    start: true,
                    cache: true,
                    onsuccess: function (data) {
                        let windowContainer = window.PopupWindowManagerAnalogs?.[uniq_id]?.contentContainer
                        if (windowContainer?.innerHTML) {windowContainer.innerHTML = data;}
                        $(window).lazyLoadXT(); // ленивая загрузка фото
                    },
                    onfailure: function (data) {
                        let windowContainer = window.PopupWindowManagerAnalogs?.[uniq_id]?.contentContainer
                        if (windowContainer?.innerHTML) {windowContainer.innerHTML = data;}
                        $(window).lazyLoadXT(); // ленивая загрузка фото
                    }
                });
            } else {
                window.PopupWindowManagerAnalogs?.[uniq_id]?.show();
            }
        },
    },
    mounted() { },
    props: {
        'productId': Number,
        'productAnalog': String
    },
    template: `
            <div
                v-if="catalogProductHaveAnalog && !isAnalog"
                :id="'ANALOG_'+productId"
                @click.stop="showAnalogs"
                :title="localize.HAVE_ANALOGS"
                data-toggle="tooltip"
                data-placement="bottom"
                class="text-danger pointer"
                >
                <i class="fas fa-funnel-dollar"></i>
            </div>`
});
BX.addCustomEvent("OnAfterUserStoreInit", BX.proxy(function () {
    if (typeof userStore !== 'undefined') userStore.commit("catalog/addProductSettingsModule", { name: 'vue-product-quantity-analog-toggle-button' });
}, this));
